<script setup lang="ts">
import { faArrowRight } from '@fortawesome/pro-light-svg-icons'
import { TabsContent, TabsList, TabsRoot, TabsTrigger } from 'reka-ui'
import { byPublishedDate } from '~/utils/crystallize/article'

definePageMeta({
  layout: 'nettbutikk',
  colorMode: 'light',
  theme: 'blurple',
  name: 'articles-index',
})

const { data, suspense } = useArticles()

await suspense()

const groups = computed(() => {
  const sorted = [...data.value?.children ?? []].sort(byPublishedDate)

  const groups = new Map<string, CrystallizeArticle[]>()

  for (const article of sorted) {
    const year = String(article?.components?.published?.getFullYear() ?? new Date().getFullYear())

    if (!groups.has(year)) {
      groups.set(year, [])
    }

    groups.get(year)?.push(article)
  }

  return groups
})

const defaultYear = computed(() => String(Math.max(...Array.from(groups.value.keys()).map(Number))))

useHead({
  bodyAttrs: {
    class: 'bg-blurple-50',
  },
})
</script>

<template>
  <ContentGrid is="article" class="pt-16 pb-48">
    <TabsRoot :default-value="defaultYear" class="full-width-content">
      <section class="w-full flex flex-col gap-l mb-20">
        <h1>Aktuelt</h1>

        <ClientOnly>
          <TabsList>
            <TabsTrigger v-for="[year] in groups" :key="year" :value="year" class="border-b border-blurple-400">
              <Button variant="tertiary" color="blurple" :icon="faArrowRight" class="rounded-lg">
                {{ year }}
              </Button>
            </TabsTrigger>
          </TabsList>
        </ClientOnly>
      </section>

      <TabsContent v-for="[year, articles] in groups" :key="year" :value="year">
        <NettbutikkArticleCardList :articles="articles" />
      </TabsContent>
    </TabsRoot>
  </ContentGrid>
</template>

<style scoped lang="postcss">
[data-state='active'] {
  @apply border-none;

  > button {
    @apply bg-blurple-400 text-white fill-white;
  }
}
</style>
